<template>
  <div :class="['list-item-wrapper', scope]" @mouseenter="toExpand" @mouseleave="doRestore">
    <div class="list-item">
      <div class="item-top">
        <div class="item-tags" v-if="colorItem.image_tags">
          <!-- 图片标签 -->
          <img v-for="(label, index) in colorItem.image_tags" :key="index" :src="label" class="item-tag image-label" />
        </div>
        <div class="item-image" @mouseenter="toViewFRImg" @mouseleave="doResetFRImg">
          <router-link :to="getProductRoutePath(data)">
            <img :src="viewImg" />
          </router-link>
        </div>
      </div>
      <div class="item-bottom">
        <div v-if="scope == 'list'" class="item-swatches">
          <div class="item-swatches-wrapper">
            <div class="item-swatches-items">
              <template v-if="allColors.length > 3">
                <!-- <i :class="['iconfont', xSwiper && xSwiper.isBeginning ? 'disabled' : 'enabled']" @click="goColor(-1)">&#xe615;</i> -->
                <swiper class="item-colors" :options="swiperOption" ref="xSwiper">
                  <swiperSlide class="item-colors-swatch" v-for="(color, colorIndex) in allColors" :key="colorIndex">
                    <router-link class="color-image" :to="getProductRoutePath(color)">
                      <img :src="color.cover" @mouseenter="setViewImg(color)" @mouseleave="resetViewImg"
                        :alt="color.name" :title="color.name" />
                    </router-link>
                  </swiperSlide>
                  <i class="iconfont icon-left-arrow" slot="button-prev">&#xe615;</i>
                  <i class="iconfont icon-right-arrow" slot="button-next">&#xe628;</i>
                </swiper>
                <!-- <i :class="['iconfont', xSwiper && xSwiper.isEnd ? 'disabled' : 'enabled']" @click="goColor(+1)">&#xe628;</i> -->
              </template>
              <template v-else>
                <div class="item-colors">
                  <div class="item-colors-swatch" v-for="(color, colorIndex) in allColors" :key="colorIndex">
                    <router-link class="color-image" :to="getProductRoutePath(color)">
                      <img :src="color.cover" @mouseenter="setViewImg(color)" @mouseleave="resetViewImg"
                        :alt="color.name" :title="color.name" />
                    </router-link>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- 品牌名：列表中存在品牌项时, 无品牌项渲染空占位(高度由 min-height 撑起), 保证商品名对齐 -->
        <div class="item-detail-brand" v-if="(data.brand && data.brand.name) || hasBrand">{{ data.brand ?
          data.brand.name : ''
        }} </div>
        <div class="item-name">
          <router-link :to="getProductRoutePath(data)">{{ data.name }}</router-link>
        </div>
        <template v-if="isShowOriginalPrice(data) && isGwMdEnablePoint">
          <div class="item-pricing has-original_price">
            <span class="rmb-symbol">￥</span>{{ data.price }}
            <span class="item-original_price">
              <span class="rmb-symbol">￥{{ data.original_price }}</span>
            </span>
          </div>
        </template>
        <template v-else>
          <!-- 未开启积分折扣或无原价时，展示原价而非现价 -->
          <div class="item-pricing"><span class="rmb-symbol">￥</span>{{ data.price }}</div>
        </template>

        <div class="item-tags" v-if="hasItemTags">
          <!-- 性别标签 -->
          <div class="item-tag" v-if="data.gender.name">
            {{ data.gender.name }}
          </div>
          <template v-if="scope == 'list'">
            <!-- 自定义标签 （新客） -->
            <template v-if="Array.isArray(data.custom_tags) && calcIsShowCustomerTag && data.custom_tags">
              <div v-for="(label, index) in data.custom_tags" :key="'custom' + index" class="item-tag custom-tags">
                {{ label }}
              </div>
            </template>
            <!-- 新品标签 -->
            <div class="item-tag" v-if="isNewProduct(data)">
              新品
            </div>
            <!-- 文字标签 -->
            <div class="item-tag" v-if="data.product_label && typeof data.product_label === 'string'">
              {{ data.product_label }}
            </div>
            <template v-else-if="Array.isArray(data.product_label)">
              <div v-for="(label, index) in data.product_label" :key="index" class="item-tag">
                {{ label }}
              </div>
            </template>
            <!-- 预售标签 -->
            <div class="item-tag" v-if="data.is_pre_sales === 1">
              预售
            </div>
          </template>
        </div>
        <button class="item-view" v-if="!isGoodsColorDisabled(data.id, data.color)"
          @click="toView(data.id, data.color || data.colors)">快速购买</button>
      </div>

    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import utils from "@/utils";
import storeFunc from "@/utils/storeFunc";
export default {
  name: "ListItem",
  components: { swiper, swiperSlide },
  props: {
    data: {
      type: Object,
      required: true
    },
    // 用于区分不用作用域以便处理样式
    scope: {
      type: String,
      default: "list",
      validator(value) {
        // 列表项组件可用于"类目列表"、"相关推荐"、"最近浏览"中
        return ["list", "recommend", "history"].indexOf(value) != -1;
      }
    },
    // 是否允许显示原价（受 gw_md_enable 配置控制）
    isGwMdEnablePoint: {
      type: Boolean,
      default: true
    },
    // 列表中是否存在品牌项: 存在时无品牌项也渲染品牌占位, 保证商品名对齐
    hasBrand: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 色板列表: data.colors 只有当前商品色, 拼上 related_pdp 各兄弟商品的颜色(与 PDP allColors 口径一致)
    allColors() {
      return [
        ...(this.data?.colors || []),
        ...(this.data?.related_pdp?.flatMap((item) => item?.colors || []) || [])
      ];
    },
    colorItem() {
      //当前查看颜色
      return this.data?.colors?.find(i => i.id === this.selectedColor) || {}
    },
    // 标签区展示条件: 任一标签数据存在即显示(文字/自定义/新品/预售/性别)
    hasItemTags() {
      const data = this.data || {};
      return !!(
        data.product_label ||
        data.custom_tags ||
        this.isNewProduct(data) ||
        data.is_pre_sales === 1 ||
        (data.gender && data.gender.name)
      );
    },
    calcIsShowCustomerTag() {
      if (["history", "recommend"].includes(this.scope)) {
        return this.$store.state.isShowCustomerTag && this.$store.state.tagsConfig.show_page.includes(this.scope)
      }
      return this.$store.state.isShowCustomerTag;
    },
  },
  data() {
    return {
      viewImg: '',
      selectedColor: null,//当前查看颜色
      xSwiper: {},
      swiperOption: {
        slidesPerView: 3,
        navigation: {
          nextEl: '.icon-right-arrow',
          prevEl: '.icon-left-arrow'
        },
        on: {
          slideChangeTransitionEnd: () => {
            console.log(this?.xSwiper?.activeIndex);
          }
        }
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    isShowOriginalPrice: utils.isShowOriginalPrice,
    isGoodsColorDisabled: storeFunc.isGoodsColorDisabled,
    isNewProduct: utils.isNewProduct,
    init() {
      this.resetViewImg();
    },
    toExpand(evt) {
      if (this.scope !== 'list') return false;
      if (window.innerWidth <= 1024) return false;
      let dom = evt.target || evt.srcElement;
      let oHeight = window.getComputedStyle(dom, null).height;
      if (dom.style.setProperty) {
        dom.style.setProperty('height', oHeight);
      } else {
        dom.style.height = oHeight;
      }
      if (dom.classList && dom.classList.add) {
        dom.classList.add('active');
      } else {
        dom.className = dom.className + ' active';
      }
    },
    doRestore(evt) {
      if (this.scope !== 'list') return false;
      if (window.innerWidth <= 1024) return false;
      let dom = evt.target || evt.srcElement;
      if (dom.classList && dom.classList.remove) {
        dom.classList.remove('active');
      } else {
        dom.className = dom.className.replace(/active/g, '').replace(/\s/g, ' ');
      }
      if (dom.style.removeProperty) {
        dom.style.removeProperty('height');
      } else {
        dom.style.height = '';
      }
    },
    // Set Front-Right view
    toViewFRImg() {
      this.viewImg = this.data?.hoverCover || this.data?.images?.[1];
    },
    // Reset Front-Right view
    doResetFRImg() {
      this.viewImg = this.data?.cover || this.data?.images?.[0];
    },
    // 设置颜色对应的图
    setViewImg(color) {
      this.viewImg = color?.cover;
      this.selectedColor = color?.id;
    },
    // 还原颜色对应的图
    resetViewImg() {
      this.viewImg = this.data?.cover || this.data?.images?.[0];
      this.selectedColor = this.data?.color || this.data?.colors?.[0]?.id;
    },
    goColor(offset) {
      if (offset == -1) {
        this.xSwiper.slidePrev();
      } else {
        this.xSwiper.slideNext();
      }
    },
    toView(id, color) {
      // 附带 style_number: 快速购买弹窗查详情时作为 sku 参数
      const style_number = this.data.style_number;
      if (Array.isArray(color)) {
        this.$emit('itemview', { id, color: color?.[0]?.id, style_number });
      } else {
        this.$emit('itemview', { id, color, style_number });
      }
    }
  },
  watch: {
    'data'() {
      this.init();
      this.$nextTick(() => {
        this.xSwiper = this.$refs?.xSwiper?.swiper;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$item-width: 249px;

.list-item-wrapper {
  box-sizing: border-box;
  height: 100%;
  background: #fff;
  color: #999;
  padding-bottom: 20px;
  position: relative;
  text-align: center;
  display: flex;
  align-items: flex-end;

  .item-top {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 32px;
    position: relative;

    .item-tags {
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 0 0 10px;
    }

  }

  .list-item {
    position: relative;
    background: #FFF;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .item-image {
      height: auto;

      a {
        img {
          width: $item-width;
          max-width: 100%;
          // height: 187px;
          height: auto;
          margin: auto;
        }
      }
    }

    .item-swatch-count {
      font-weight: 700;
      font-size: calc(0.75rem * 1.6);
      line-height: calc(1.375rem * 1.6);
      margin: 0;
      color: #666;
      text-transform: capitalize;
      width: 100%;
    }

    .item-swatches {
      min-height: 63px;
      margin-top: calc(.3125rem * 1.6);
      margin: 0 auto;
      position: relative;
      display: none;

      .item-swatches-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;

        .item-swatches-items {
          display: flex;
          align-items: center;
          width: 225px;

          .iconfont {
            font-weight: 400;
            cursor: pointer;

            &.disabled {
              color: #EFEFEF;
            }
          }

          .icon-left-arrow,
          .icon-right-arrow {
            font-size: 24px;
            position: absolute;
            top: 50%;
            z-index: 1;
            transform: translate(0, -50%);

            &.swiper-button-disabled {
              color: #efefef;
            }
          }

          .icon-left-arrow {
            left: 0;
          }

          .icon-right-arrow {
            right: 0;
          }

          .item-colors {
            width: 195px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;

            // & ::v-deep .swiper-wrapper { align-items: center; }
            .item-colors-swatch {
              display: flex;
              justify-content: center;
              width: 65px;

              .color-image {
                font-weight: 400;
                display: block;
                width: 50px;
                border-bottom: 2px solid transparent;

                img {
                  width: 50px;
                  height: auto;
                }

                &:hover {
                  border-bottom: 2px solid #999;
                }
              }
            }
          }
        }
      }
    }

    .item-detail-brand {
      color: #BABEC2;
      font-weight: 700;
      font-size: 15px;
      margin-bottom: 4px;
      font-style: normal;
      // 固定行高: 品牌有值与空占位行高一致; min-height 撑起空占位
      line-height: 1.4;
      min-height: 1.4em;
      text-align: center;
    }

    .item-name {
      padding-left: 20px;
      padding-right: 20px;
      height: auto;
      line-height: calc(1rem * 1.6) !important;
      margin-bottom: 5px !important;

      a {
        font-weight: 700;
        font-size: calc(1rem * 1.6);
        margin: 0;
        line-height: calc(1.375rem * 1.6);
        color: #000;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .item-classification {
      font-size: calc(0.625rem * 1.6);
      font-weight: 600;
      color: #333;
      margin-bottom: 5px !important;
      line-height: calc(0.75rem * 1.6) !important;
      text-align: center !important;
    }

    .item-pricing {
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 10px;
      line-height: calc(1.25rem * 1.6);
      font-weight: 400;
      font-size: calc(0.875rem * 1.6);
      color: #4d4d4c;

      &.has-original_price {
        color: #212322;
        font-weight: 700;

        .item-original_price {
          margin-left: 8px;
          color: #4d4d4c;
          font-weight: 400;
          text-decoration: line-through;
        }
      }
    }

    .item-view {
      font-weight: 400;
      font-size: calc(0.875rem * 1.6);
      color: #fff;
      position: absolute;
      bottom: 20px;
      display: none;
      left: 0;
      width: 95%;
      padding: 0.5em 0;
      margin: 0 2.5%;
      background-color: #7f0019;
      cursor: pointer;
    }


    .item-bottom {
      .item-tags {
        padding: 0 20px 15px 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &.active {
    .list-item {
      position: absolute;
      left: -8px;
      top: -8px;
      height: auto;
      width: calc(100% + 16px);
      padding-bottom: 55px;
      padding-top: 8px;
      box-shadow: 0 0 9px 0 #ccc;
      z-index: 1;

      .item-swatch-count {
        display: none;
      }

      .item-swatches {
        display: block;
      }

      .item-view {
        display: block;
      }
    }
  }

  .item-tags {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    width: $item-width;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 12px 10px 8px;
    gap: 8px;

    .logo {
      height: 24px;
      width: auto;

      &.designer-logo {
        height: 8px;
      }
    }

    .item-tag {
      color: #212322;
      /* 中文正文/Text-Small-12-R */
      font-family: Noto Sans CJK SC;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      /* 150% */
      padding: 0 5px;
      border: 1px solid #212322;
      background: #fff;

      &.image-label {
        border: none;
        padding: 0;
        max-height: 20px;
        height: 20px;
        width: auto;
      }
    }
  }

  // history/recommend 作用域不展示划线原价
  &.history,
  &.recommend {
    .item-original_price {
      display: none;
    }
  }
}

@media only screen and (min-width: 1024px) {
  .list-item-wrapper {
    .list-item {
      .item-image {
        a {
          img {
            min-width: 210px;
            min-height: 210px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .list-item-wrapper {
    .list-item {
      .item-detail-brand {
        color: #BABEC2;
        font-weight: 700;
        font-size: 10px;
        margin-bottom: 4px;
      }

      .item-bottom {
        .item-tags {
          padding-bottom: 0px;
        }
      }

      .item-name {
        line-height: 24px;
      }
    }
  }
}
</style>
